<template>
    <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.78059 1.54488L13.9056 3.08988C14.6931 3.38988 15.3381 4.31988 15.3306 5.16738V11.2424C15.3306 11.8499 14.9331 12.6449 14.4456 13.0124L10.3206 16.0949C9.59309 16.6424 8.40059 16.6424 7.67309 16.0949L3.54809 13.0124C3.06059 12.6524 2.66309 11.8499 2.66309 11.2424V5.16738C2.66309 4.31988 3.30809 3.38988 4.10309 3.08988L8.22809 1.54488C8.65559 1.38738 9.35309 1.38738 9.78059 1.54488ZM12.7508 5.86945H11.2508V6.74399L8.05011 9.94466L6.75062 8.6452V8.16574H5.25062V9.26653L8.05012 12.066L12.7508 7.36531V5.86945Z"
            fill="#FF9E48"
        />
    </svg>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>